import * as ko from "knockout";
export class ui_tab {
  href: string;
  label: string;
  counter?: KnockoutObservable<number>;
  hasChartButton?: boolean;
  control?: string;
  isRequired?: KnockoutObservable<boolean> | KnockoutComputed<boolean>;
  isActive?: KnockoutObservable<boolean>;
  isRequiredClass?: KnockoutComputed<string>;
  isDisplayed?: KnockoutObservable<boolean> | KnockoutComputed<boolean>;
  hasError?: KnockoutObservable<boolean>;
  hasErrorClass?: KnockoutComputed<string>;
  readonly: KnockoutObservable<boolean>;
  tab_value: KnockoutObservable<string>;
  req_completion: KnockoutObservable<boolean>;
  req_rejection: KnockoutObservable<boolean>;
  req_hold: KnockoutObservable<boolean>;

  active_icon_color?: KnockoutObservable<string | undefined>;

  constructor(props?: ui_tab | any) {
    this.readonly = typeof props?.readonly === "function" ? props.readonly : ko.observable(props?.readonly || false);
    this.href = props?.href;
    this.label = props?.label;
    this.control = props?.control;
    this.hasChartButton = props?.hasChartButton ?? false;

    this.counter = typeof props?.counter === "function" ? props.counter : ko.observable(props?.counter ?? 0);

    this.isActive = typeof props?.isActive === "function" ? props?.isActive : ko.observable(props?.isActive ?? false);

    this.isRequired =
      typeof props?.isRequired === "function" ? props?.isRequired : ko.observable(props?.isRequired ?? false);

    this.isDisplayed =
      typeof props?.isDisplayed === "function" ? props?.isDisplayed : ko.observable(props?.isDisplayed ?? true);

    this.hasError = props?.hasError ?? ko.observable(false);

    this.isRequiredClass = ko.computed(() => {
      return this.isRequired() && !this.readonly() ? "requiredMark" : "";
    });

    this.hasErrorClass = ko.computed(() => {
      return this.hasError() && !this.readonly() ? "tab-error" : "";
    });

    this.tab_value = ko.observable(props?.tab_value);
    this.req_completion = ko.observable(props?.req_completion);
    this.req_rejection = ko.observable(props?.req_rejection);
    this.req_hold = ko.observable(props?.req_hold);

    this.active_icon_color = ko.observable(props?.active_icon_color);
  }

  setCounter(value: number): void {
    if (typeof value === "number") {
      this.counter(value);
    } else {
      console.error("Counter value must be a number");
    }
  }
}
